import React from 'react'
import {  Backdrop as MuiBackdrop, BackdropProps } from '@material-ui/core'
import * as styles from './backdrop.module.less'

const Backdrop: React.FC<BackdropProps> = (props) => {
  return <MuiBackdrop {...props} className={styles.backdrop}/>
}

export default Backdrop